import { AgGridReact } from "ag-grid-react";
import AgGridUtils from "../../../../utils/aggrid-utils";
import { useSignedAlarmListQuery } from "./use-signed-alarm-list-query";
import ProjectUtils from "../../../../utils/project-utils";

const SignedAlarmList = ({ autoAssignId }) => {
    const { data} = useSignedAlarmListQuery(autoAssignId);

    const rowData = data?.rows ?? [];

    const knownedSources = [
        {name: "EXTERN-MJ", formattedName: "Córtex"},
        {name: "EXTERN-CELEPAR", formattedName: "Celepar"},
        {name: "EXTERN-DETRAN_AM", formattedName: "DETRAN-AM"},
        {name: "EXTERN-DETRANES", formattedName: "DETRAN-ES"},
        {name: "EXTERN-PRF", formattedName: "PRF"},
        {name: "EXTERN-SENTRYFACE", formattedName: "Sentry face"},
        {name: "EXTERN-SESP_SP", formattedName: "Muralha Paulista"},
        {name: "PMERJ", formattedName: "PMERJ"},
    ];

    function formatSources(value) {
        if (!value || !value.length) return "";

        const formatted = value.map((str) => {
            const match = knownedSources.find((obj) => obj.name === str);
            return match ? match.formattedName : str;
        });

        return formatted.join(", ");
    }

    const columnDefs = [
        {
            headerName: "Data/Hora",
            field: "date",
            flex: 1,
            sortable: true,
            sort: "desc",
            valueFormatter: (params) =>
                params.value
                    ? ProjectUtils.formatDate(params.value, "DD/MM/YYYY HH:mm")
                    : "",
        },
        {
            headerName: "Placa",
            field: "plate",
            flex: 1,
            cellClass: "uppercase font-bold",
        },
        {
            headerName: "Câmera",
            field: "laneCode",
            flex: 1,
        },
        {
            headerName: "Origem",
            field: "source",
            valueFormatter: (params) => formatSources(params.value),
            flex: 1,
        },
        {
            headerName: "Tipo",
            field: "eventType",
            valueFormatter: ({ value }) => {
                if (!value) return "";
                return value === "ALARM" ? "Alarme" : value === "EXTERN_EVENT" ? "Evento de integrações" : "";
            }
        },
    ];

    return (
        <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            pagination
            paginationPageSizeSelector={[20, 50, 100, 500]}
            suppressCellFocus
            animateRows={false}
            onFilterChanged={AgGridUtils.filterChangedNoRowsOverlay}
            gridOptions={{ localeText: AgGridUtils.localization() }}
            theme={AgGridUtils.generalTheme()}
        />
    )
}

export default SignedAlarmList;